import { Component, Input, OnInit } from "@angular/core";
import { ModalService } from "@core-services/modal.service";
import { Network } from "@modules/+new/payments/features/crypto-deposit/domain/entities/network.model";
import { PaymentsCryptocoin } from "@modules/+new/payments/shared-payments/entities/payments-cryptocoin.model";
import { config } from "@config";
import { TranslationService } from "@core-services/translation.service";
import { SendSelectRecipientComponent } from "@modules/main/components/step-summary/sending-modal/send-select-recipient/send-select-recipient.component";
import { SendTrackingFacade } from "@modules/main/components/step-summary/sending-modal/services/send-tracking.facade";

@Component({
	selector: "send-warning",
	templateUrl: "./send-warning.component.html",
	styleUrls: ["./send-warning.component.scss"],
	standalone: false
})
export class SendWarningComponent implements OnInit {
	@Input() selectedNetwork: Network = null;
	@Input() selectedCryptocoin: PaymentsCryptocoin = null;
	@Input() walletId: string = "";
	public warningScamsText: string = "";
	public memoText: string = "";

	constructor(
		private readonly modalService: ModalService,
		private readonly translationService: TranslationService,
		public readonly trackingFacade: SendTrackingFacade
	) {}

	ngOnInit(): void {
		this.trackingFacade.trackWarningViewed();
		this.warningScamsText = this.getWarningScamsText();
		this.memoText = this.getMemoText();
	}

	public onBackButtonClick(): void {
		this.modalService.pop();
	}

	public onCancelButtonClick(): void {
		this.modalService.popAll();
	}

	public onConfirm(): void {
		this.trackingFacade.trackWarningButtonUnderstandClicked();
		this.modalService
			.create(SendSelectRecipientComponent, {
				selectedCryptocoin: this.selectedCryptocoin,
				selectedNetwork: this.selectedNetwork,
				accountWalletId: this.walletId
			})
			.present();
	}

	private getWarningScamsUrl(): string {
		return this.translationService.getHdLink() + config.externalPaths["send"]["onlineScam"];
	}

	private getWarningScamsText(): string {
		const link = `<a target="_blank" href="${this.getWarningScamsUrl()}">${this.translationService.translate(
			"send_warning_scam_alert_link"
		)}</a>`;
		return `<div class="send_warning_scam_alert"> ${this.translationService.translate("send_warning_scam_alert", [
			link
		])}</div>`;
	}

	private getMemoText(): string {
		let memoType = "the_message_title";
		if (this.selectedNetwork.destination_tag?.type === "memo") {
			memoType = "the_memo_title";
		} else if (this.selectedNetwork.destination_tag?.type === "destination_tag") {
			memoType = "the_destination_tag";
		}
		return this.translationService.translate("send_warning_memo", [this.translationService.translate(memoType)]);
	}
}
